import React from 'react'
import PropTypes from 'prop-types'

/**
 * Component for conditionally rendering a component while still rendering its children.
 *
 * @returns {function} Component
 */
const Conditional = ({
  condition,
  component: Component,
  props,
  ...rest
}) => {
  if (!!condition && !!Component) {
    return <Component {...props} {...rest} />
  }

  return <React.Fragment {...rest} />
}

Conditional.propTypes = {
  condition: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.node,
    PropTypes.shape({}),
  ]),
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  props: PropTypes.shape({}),
}

Conditional.defaultProps = {
  condition: false,
  component: null,
  props: {},
}

export default Conditional
